export default ['de', 'it', 'pl', 'hu'];
